
import MSColumn2D from './mscolumn2d';
import ColumnDataset from '../_internal/datasets/column';
import CartesianStackGroup from '../_internal/datasets/groups/cartesian.stack';

class StackedColumn2D extends MSColumn2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'StackedColumn2D';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'StackedColumn2D';
  }

  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Stacked Column Chart';
    config.isstacked = true;
  }

  /** This method return the dataset definations for this charts **/
  getDSdef () {
    return ColumnDataset;
  }
  /** This method return the dataset-group definations for this charts **/
  getDSGroupdef () {
    return CartesianStackGroup;
  }
}
export default StackedColumn2D;
